import apiClient from '../client';
import {
  Application,
  Attribute,
  OfferDetail,
  OfferFilters,
  OfferListItem,
  PaginatedResponse,
} from '../types';

export const offersApi = {
  list: async (filters?: OfferFilters): Promise<PaginatedResponse<OfferListItem>> => {
    const response = await apiClient.get<PaginatedResponse<OfferListItem>>('/offers/', {
      params: filters,
    });
    return response.data;
  },

  get: async (id: number): Promise<OfferDetail> => {
    const response = await apiClient.get<OfferDetail>(`/offers/${id}/`);
    return response.data;
  },

  create: async (data: FormData): Promise<OfferDetail> => {
    const response = await apiClient.post<OfferDetail>('/offers/', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  update: async (id: number, data: FormData): Promise<OfferDetail> => {
    const response = await apiClient.patch<OfferDetail>(`/offers/${id}/`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/offers/${id}/`);
  },

  getMyOffers: async (filters?: OfferFilters): Promise<PaginatedResponse<OfferListItem>> => {
    const response = await apiClient.get<PaginatedResponse<OfferListItem>>('/offers/my/', {
      params: filters,
    });
    return response.data;
  },

  publish: async (id: number): Promise<{ message: string; expires_at: string }> => {
    const response = await apiClient.post(`/offers/${id}/publish/`);
    return response.data;
  },

  boost: async (id: number): Promise<{ message: string }> => {
    const response = await apiClient.post(`/offers/${id}/boost/`);
    return response.data;
  },

  getApplications: async (
    offerId: number,
    page?: number,
  ): Promise<PaginatedResponse<Application>> => {
    const response = await apiClient.get<PaginatedResponse<Application>>(
      `/offers/${offerId}/applications/`,
      { params: { page } },
    );
    return response.data;
  },
};

export const applicationsApi = {
  create: async (data: FormData): Promise<{ message: string; id: number }> => {
    const response = await apiClient.post('/applications/', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

export const attributesApi = {
  list: async (): Promise<Attribute[]> => {
    const response = await apiClient.get<Attribute[]>('/attributes/');
    return response.data;
  },

  get: async (id: number): Promise<Attribute> => {
    const response = await apiClient.get<Attribute>(`/attributes/${id}/`);
    return response.data;
  },
};

export default offersApi;
